export const CELL_HEIGHT = 37
export const MIN_CELL_WIDTH = 75
export const GROUP_SEPARATOR_HEIGHT = Math.floor(CELL_HEIGHT / 2.5)
export const TABLE_HEADER_HEIGHT = CELL_HEIGHT - 3
